import { createAutocompleteLoader as createBaseLoader } from '@connect-x-app/hybrid-data-access';
import { Option } from '@connect-x-app/shared-types';
import { mapToOptions } from '@connect-x-app/web-utils';

export const createAutocompleteLoader =
  (...urls: string[]) =>
  async (search: string): Promise<Option[]> => {
    try {
      const results = await createBaseLoader(...urls)(search);
      return mapToOptions(results);
    } catch {
      return [];
    }
  };
